import { postDataToServer } from '../../../util';

export class RiskScoreAcceptanceModule {
  constructor(baseURL, httpHeaders) {
    this.baseURL = baseURL;
    this.httpHeaders = httpHeaders;
  }

  acceptRiskScore = async (payload) => {
    const { customerKey, riskRating, notes } = payload;

    const data = { customerKey, riskRating, notes };

    const response = await postDataToServer(
      `${this.baseURL}/customers/acceptRiskScore`,
      data
    );

    if (response instanceof Error) throw response;
    return response;
  };
}
